import userReducer from './user.slice'

export default userReducer
